<template>
  <div class="login-wrap">
    <div class="login">
      <img
        class="logo"
        :src="$store.state.webConfig.web_logo"
        @click="$router.push({ name: 'Index' })"
      />
      <div class="left">
        <img class="left-img" src="@/assets/images/login/left@2x.png" />
      </div>
      <div class="login-main">
        <StudentLogin></StudentLogin>
      </div>
    </div>
  </div>
</template>
<script>
import StudentLogin from "../components/Login.vue";
export default {
  name: "Login",
  components: {
    StudentLogin,
  },
  mounted() {
    document.body.style.overflow = "unset";
    document.documentElement.style.overflow = "unset";
  },
  beforeDestroy() {
    document.body.style.overflow = "auto !important";
    document.documentElement.style.overflowY = "scroll";
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";

.login-wrap {
  height: 100vh;
  display: flex;
  align-items: center;
  background-size: 100% 100%;
  background-image: url("~@/assets/images/login/back@2x.png");
  background-color: white;
  justify-content: center;
}
.login {
  background: rgba(255, 255, 255, 1);
  box-shadow: -7px 3px 13px 0px rgba(236, 236, 236, 0.46);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.login-main {
  height: 100%;
}
.left {
  img {
    display: block;
  }
}
.logo {
  cursor: pointer;
  position: absolute;
  top: 50px;
  left: 42px;
}

@mixin fix() {
  .login {
    width: reponsive(1360);
    height: reponsive(760);
  }

  .left {
    margin: 0 reponsive(88);
  }

  .logo {
    height: reponsive(45);
  }

  .left-img {
    width: reponsive(642);
    height: reponsive(540);
  }

  .login-main {
    width: reponsive(422);
  }
}

@include fix();
</style>
